exports.cs = {
  UNIFORM_DETAIL: {
    INVALID_POBOCKY: 'Vyberte pobočku ze seznamu.',
    POBOCKY_PLACEHOLDER: 'Vyberte pobočku ze seznamu...',
    POBOCKY_NO_RESULTS: 'Nebylo nic nalezeno.'
  }
}
